import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { apiUrl } from '../../services/http/http';
import '../Profile.css';
import auth from '../../services/util/auth';
import masterListSource from '../MasterList';

const CreateCareerPathway = props => {
  let history = useHistory();
  const frameworkName = props.location.pathname.split('/')[2];
  const frameworkVersion = props.location.pathname.split('/')[3];
  const [profiles, setProfiles] = useState(null);
  const [careerPathway, setCareerPathway] = useState({
    title: '',
    description: '',
    profiles: []
  });
  const [vfDropdown, setVfDropdown] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  var userName = auth.currently_logged_in_user.username;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetch(
          `${apiUrl}/api/${frameworkName}/${frameworkVersion}/profiles/?_format=json&source=competencyhub&timestamp=${Date.now()}`
        )
          .then(Response => Response.json())
          .then(findresponse => {
            setProfiles(findresponse);
          });
      } catch (e) {
        console.log(e.message);
      }
    };

    fetchData();
  }, [frameworkVersion, frameworkName, userName]);

  const callVFDropDown = () => {
    if (vfDropdown === false) {
      setTimeout(() => {
        window.vfDropdown();
      }, 1000);
      setVfDropdown(true);
    }
  };

  const updateCareerPathway = e => {
    e.preventDefault();
    if (selectedProfile) {
      setCareerPathway(prevCareerPathway => {
        const updatedProfiles = prevCareerPathway.profiles || [];
        if (!updatedProfiles.some(p => p.id === selectedProfile.id)) {
          return {
            ...prevCareerPathway,
            profiles: [...updatedProfiles, selectedProfile]
          };
        }
        return prevCareerPathway;
      });
    }
  };

  const handleSave = e => {
    // Implement save functionality here
    e.preventDefault();
    const payload = {
      title: careerPathway.title,
      description: careerPathway.description,
      profiles: careerPathway.profiles,
      frameworkName: frameworkName,
      frameworkVersion: frameworkVersion
    };

    fetch(
      `${apiUrl}/api/${frameworkName}/${frameworkVersion}/career-pathways/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': `${auth.csrf_token}`
        },
        withCredentials: true,
        credentials: 'include',
        body: JSON.stringify(payload)
      }
    )
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to save career pathway');
        }
        return response.json();
      })
      .then(data => {
        history.push(
          `/framework/${frameworkName}/${frameworkVersion}/career-pathway/${
            data.nid
          }/view`
        );
      })
      .catch(error => {
        console.error('Error saving career pathway:', error);
      });
  };

  return (
    <div>
      <h2>
        Create Career Pathway in{' '}
        {
          masterListSource.find(element => element['title'] === 'iscb')[
            'new_desc'
          ]
        }{' '}
      </h2>

      {vfDropdown === false ? callVFDropDown() : ''}
      {profiles && (
        <div>
          <form className="vf-form" onSubmit={e => updateCareerPathway(e)}>
            <div className="vf-form__item">
              <label htmlFor="pathway-title" className="vf-form__label">
                Title
              </label>
              <input
                type="text"
                id="pathway-title"
                className="vf-form__input"
                placeholder="Enter pathway title"
                value={careerPathway?.title ?? ''}
                onChange={e => {
                  const { value } = e.target; // copy it before async setState
                  setCareerPathway(prevCareerPathway => ({
                    ...prevCareerPathway,
                    title: value
                  }));
                }}
                required
                autoComplete="off"
              />
            </div>
            <div className="vf-form__item">
              <label htmlFor="pathway-description" className="vf-form__label">
                Description
              </label>
              <textarea
                id="pathway-description"
                className="vf-form__textarea"
                placeholder="Enter pathway description"
                onChange={e => {
                  const { value } = e.target; // copy it before async setState
                  setCareerPathway(prevCareerPathway => ({
                    ...prevCareerPathway,
                    description: value
                  }));
                }}
                required
              />
            </div>
            <div className="vf-form__item">
              <label htmlFor="vf-form__select" className="vf-form__label">
                Select career profile(s)
              </label>
              <span
                style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
              >
                <select
                  className="vf-form__select"
                  id="vf-form__select"
                  onChange={e => {
                    const selected = profiles.find(
                      profile => profile.id === e.target.value
                    );
                    setSelectedProfile(selected);
                  }}
                  value={selectedProfile ? selectedProfile.id : ''}
                  required
                >
                  <option value="" disabled>
                    Select a profile
                  </option>
                  {profiles.map(profile => (
                    <option key={profile.id} value={profile.id}>
                      {profile.title} - {profile.job_title}{' '}
                    </option>
                  ))}
                </select>
                <button
                  className="vf-button vf-button--primary vf-button--sm "
                  onClick={e => updateCareerPathway(e)}
                >
                  Add to career pathway
                </button>
              </span>
            </div>
            {careerPathway && careerPathway?.profiles.length > 0 && (
              <div>
                <div className="career-timeline">
                  {careerPathway?.profiles.map((profile, index) => (
                    <article
                      key={profile.id}
                      className="vf-profile vf-profile--small vf-profile--block timeline-item"
                    >
                      <div className="timeline-content">
                        <center>
                          <img
                            alt=""
                            src={profile.image[0] ? profile.image[0].url : ''}
                            width={'60px'}
                            height={'auto'}
                            loading="lazy"
                            className="vf-profile__image"
                          />
                        </center>
                        <h4 className="vf-profile__title">
                          {profile.job_title}
                        </h4>
                        <p className="vf-profile__text">
                          {profile.seniority_level
                            ? profile.seniority_level
                            : `Step ${index + 1}`}
                        </p>
                      </div>
                      {/* Remove (×) button as a small badge */}
                      <button
                        type="button"
                        aria-label="Remove profile"
                        style={{
                          position: 'absolute',
                          bottom: '-6px',
                          right: '-6px',
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          border: '1px solid #ccc',
                          backgroundColor: '#f5f5f5',
                          color: '#666',
                          fontWeight: 'bold',
                          fontSize: '14px',
                          lineHeight: '18px',
                          textAlign: 'center',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setCareerPathway(prev => ({
                            ...prev,
                            profiles: prev.profiles.filter(
                              p => p.id !== profile.id
                            )
                          }));
                        }}
                      >
                        x
                      </button>
                      {/* Draw connecting line except for last item */}
                      {index < careerPathway?.profiles.length - 1 && (
                        <div className="timeline-line" />
                      )}
                    </article>
                  ))}
                </div>
              </div>
            )}
            <button
              type="submit"
              className="vf-button vf-button--primary vf-button--sm "
              onClick={e => handleSave(e)}
            >
              Save pathway
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default CreateCareerPathway;
